<script>
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import {
  required,
  minLength,
  integer,
  minValue,
} from 'vuelidate/lib/validators';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
const CategoriesRepository = Repositories.get('categories');
const AllocationsRepository = Repositories.get('allocations');
import Multiselect from 'vue-multiselect';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ItemSuppliers from './components/item-suppliers';
import HeaderContentLayout from '@/router/layouts/header-content-layout';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'ConfigurationItem',
  },
  components: {
    Loading,
    Multiselect,
    Tooltip,
    ItemSuppliers,
    HeaderContentLayout,
  },
  data() {
    return {
      state: this.$route.name == 'editItem' ? 'edit' : 'create',
      isLoading: false,
      defaultSupplierIdPublic: null,
      items: [
        {
          text: 'items',
          href: '/configuration/items/create',
        },
        {
          text: '',
          active: true,
        },
      ],
      formObject: {
        code: null,
        name: null,
        cadcamCode: null,
        accountingCode: null,
        totalQuantity: 0,
        orderNote: '',
        isInternalOrderNote: false,
        minQuantity: 0,
        price: 0.0,
        category: null,
        allocation: null,
        quantityType: 'unitary',
        unitType: '',
      },
      itemSuppliers: [],
      categoriesOptions: [],
      allocationsOptions: [],
    };
  },
  validations() {
    if (this.formObject.quantityType == 'unitary') {
      return {
        formObject: {
          name: { required, minLength: minLength(1) },
          code: { required, minLength: minLength(1) },
          totalQuantity: { required, integer, minValue: minValue(0) },
          minQuantity: { required, integer, minValue: minValue(0) },
          category: { required },
          quantityType: { required },
        },
      };
    } else {
      return {
        formObject: {
          name: { required, minLength: minLength(1) },
          code: { required, minLength: minLength(1) },
          totalQuantity: { required, minValue: minValue(0) },
          minQuantity: { required, minValue: minValue(0) },
          category: { required },
          quantityType: { required },
        },
      };
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      let promise1 = CategoriesRepository.getAll().then((response) => {
        this.categoriesOptions = response.data.data;
      });
      let promise2 = AllocationsRepository.getAll().then((response) => {
        this.allocationsOptions = this.groupAllocations(response.data.data);
      });

      Promise.all([promise1, promise2])
        .then(() => {
          if (this.$route.params.idPublic != undefined) {
            ItemsRepository.customREST
              .getWithItemSuppliers(this.$route.params.idPublic)
              .then((response) => {
                this.formObject.name = response.data.name;
                this.formObject.code = response.data.code;
                this.formObject.cadcamCode = response.data.cadcamCode;
                this.formObject.accountingCode = response.data.accountingCode;
                this.formObject.totalQuantity = response.data.totalQuantity;
                this.formObject.orderNote = response.data.orderNote;
                this.formObject.isInternalOrderNote =
                  response.data.isInternalOrderNote;
                this.formObject.minQuantity = response.data.minQuantity;
                this.formObject.quantityType = response.data.quantityType;
                this.formObject.unitType = response.data.unitType;

                if (response.data.allocationIdPublic != null) {
                  let allocationItems = this.allocationsOptions.reduce(
                    (acc, allocationGroup) => {
                      let location = acc.concat(allocationGroup.locations);
                      return (
                        location.filter(
                          (x) => x.idPublic === response.data.allocationIdPublic
                        ) ?? null
                      );
                    },
                    []
                  );

                  if (allocationItems != null && allocationItems.length > 0) {
                    this.formObject.allocation = allocationItems[0];
                  }
                }

                if (response.data.categoryIdPublic != null) {
                  this.formObject.category = this.categoriesOptions.find(
                    (x) => x.idPublic == response.data.categoryIdPublic
                  );
                } else {
                  this.formObject.category = null;
                }
                if (response.data.supplierIdPublic != null) {
                  this.defaultSupplierIdPublic = response.data.supplierIdPublic;
                }

                if (response.data.itemSuppliers != null) {
                  this.itemSuppliers = response.data.itemSuppliers;
                }

                this.isLoading = false;
              })
              .catch(() => {
                this.$toast.errorToast(this.$t('errors.errorLoading'));
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    onSubmit() {
      this.$v.formObject.$touch();
      if (!this.$v.formObject.$invalid) {
        this.isLoading = true;
        this.create();
      }
    },
    create() {
      let apiWrapper = {
        idPublic: null,
        name: this.formObject.name,
        code: this.formObject.code,
        cadcamCode: this.formObject.cadcamCode,
        accountingCode: this.formObject.accountingCode,
        totalQuantity: this.formObject.totalQuantity,
        orderNote: this.formObject.orderNote,
        isInternalOrderNote: this.formObject.isInternalOrderNote,
        minQuantity: this.formObject.minQuantity,
        quantityType: this.formObject.quantityType,
        unitType: this.formObject.unitType,
        allocationIdPublic:
          this.formObject.allocation != null
            ? this.formObject.allocation.idPublic
            : null,
        isNewItem: false,
        categoryIdPublic:
          this.formObject.category != null
            ? this.formObject.category.idPublic
            : null,
        supplierIdPublic: this.defaultSupplierIdPublic,
        itemSuppliers: this.itemSuppliers,
      };

      if (this.$route.name == 'editItem') {
        apiWrapper.idPublic = this.$route.params.idPublic;
        ItemsRepository.update(apiWrapper, this.$route.params.idPublic)
          .then(() => {
            this.$router.push({ name: 'itemsConfig' });
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      } else {
        apiWrapper.cadcamLink = 'none';
        ItemsRepository.create(apiWrapper)
          .then(() => {
            this.$router.push({ name: 'itemsConfig' });
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      }
    },
    cancel() {
      this.$router.push({ name: 'itemsConfig' });
    },
    groupAllocations(allocations) {
      let newArray = allocations.reduce((acc, location) => {
        let allocationGroupIdPublic = location.allocationGroupIdPublic;
        let allocationGroupName = location.allocationGroupName;

        let group = acc.find(
          (group) => group.allocationGroupIdPublic === allocationGroupIdPublic
        );
        if (!group) {
          group = {
            allocationGroupName: allocationGroupName,
            allocationGroupIdPublic: allocationGroupIdPublic,
            locations: [],
          };
          acc.push(group);
        }

        group.locations.push({
          name: location.name,
          idPublic: location.idPublic,
        });

        return acc;
      }, []);

      return newArray;
    },
    updateItem(updatedItem) {
      this.defaultSupplierIdPublic = updatedItem.supplierIdPublic;
      this.itemSuppliers = updatedItem.itemSuppliers;
    },
  },
  computed: {
    item() {
      return {
        idPublic:
          this.$route.name == 'editItem' ? this.$route.params.idPublic : null,
        supplierIdPublic: this.defaultSupplierIdPublic,
        quantityType: this.formObject.quantityType,
        itemSuppliers: this.itemSuppliers,
      };
    },
  },
};
</script>

<template>
  <HeaderContentLayout
    @ctrl-enter-pressed="onSubmit()"
    :title="
      $route.name == 'editItem' ? $t('general.edit') : $t('general.create')
    "
  >
    <template v-slot:header>
      <b-button
        type="submit"
        variant="success"
        class="mr-2"
        @click="onSubmit"
        >{{
          $route.name == 'editItem' ? $t('general.save') : $t('general.create')
        }}</b-button
      >
      <b-button
        @click="cancel()"
        tabindex="-1"
        type="button"
        variant="secondary"
        >{{ $t('general.cancel') }}</b-button
      >
    </template>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <b-form>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-code"
            :label="$t('general.code')"
            label-for="input-code"
          >
            <b-form-input
              id="input-code"
              :class="{
                'is-invalid': $v.formObject.code.$error,
              }"
              v-model="formObject.code"
              type="text"
              :placeholder="$t('general.code')"
            ></b-form-input>
            <Tooltip :validations="$v.formObject.code" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-name"
            :label="$t('general.name')"
            label-for="input-name"
          >
            <b-form-input
              id="input-name"
              :class="{
                'is-invalid': $v.formObject.name.$error,
              }"
              v-model="formObject.name"
              type="text"
              :placeholder="$t('general.name')"
            ></b-form-input>
            <Tooltip :validations="$v.formObject.name" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            id="input-group-cadcamCode"
            :label="$t('items.cadcamCode')"
            label-for="input-cadcamCode"
          >
            <b-form-input
              id="input-cadcamCode"
              v-model="formObject.cadcamCode"
              type="text"
              :placeholder="$t('items.cadcamCode')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-accountingCode"
            :label="$t('items.accountingCode')"
            label-for="input-accountingCode"
          >
            <b-form-input
              id="input-accountingCode"
              v-model="formObject.accountingCode"
              type="text"
              :placeholder="$t('items.accountingCode')"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            id="input-group-quantity-type"
            :label="$t('items.quantityType')"
            label-for="input-quantity-type"
          >
            <b-form-select
              id="input-quantity-type"
              v-model="formObject.quantityType"
              :class="{
                'is-invalid': $v.formObject.quantityType.$error,
              }"
            >
              <b-form-select-option value="unitary">{{
                $t('items.unitary')
              }}</b-form-select-option>
              <b-form-select-option value="decimal">{{
                $t('items.decimal')
              }}</b-form-select-option>
            </b-form-select>
            <Tooltip :validations="$v.formObject.quantityType" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-unit-type"
            :label="$t('items.unitType')"
            label-for="input-unit-type"
          >
            <b-form-input
              id="input-unit-type"
              v-model="formObject.unitType"
              type="text"
              :placeholder="$t('items.unitType')"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            id="input-group-category"
            :label="$t('categories.category')"
            label-for="input-category"
          >
            <multiselect
              id="input-category"
              :validator="$v.formObject.category"
              :class="{
                'is-invalid': $v.formObject.category.$error,
              }"
              v-model="formObject.category"
              :options="categoriesOptions"
              :show-labels="false"
              :searchable="false"
              :label="'name'"
              track-by="idPublic"
              :placeholder="$t('general.pickAValue')"
              ><template v-slot:noOptions>
                {{ $t('general.noResult') }}
              </template></multiselect
            >
            <Tooltip :validations="$v.formObject.category" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-allocation"
            :label="$t('general.allocation')"
            label-for="input-allocation"
          >
            <multiselect
              id="input-allocation"
              v-model="formObject.allocation"
              :options="allocationsOptions"
              group-label="allocationGroupName"
              group-values="locations"
              :show-labels="false"
              :searchable="true"
              :label="'name'"
              track-by="idPublic"
              :placeholder="$t('general.pickAValue')"
              ><template v-slot:noOptions>
                {{ $t('general.noResult') }}
              </template></multiselect
            >
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div class="group-box">
            <b-form-group
              label-cols-lg="6"
              :label="$t('inventory.inventory')"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="mb-0"
            >
              <b-form-group
                v-if="$route.name == 'createItem'"
                id="input-group-currentQuantity"
                :label="$t('items.currentQuantity')"
                label-for="input-currentQuantity"
                style="margin-left: 7px"
              >
                <b-form-input
                  id="input-currentQuantity"
                  :class="{
                    'is-invalid': $v.formObject.totalQuantity.$error,
                  }"
                  v-model="formObject.totalQuantity"
                  type="number"
                  :step="formObject.quantityType == 'unitary' ? '1' : '.00001'"
                  :placeholder="$t('items.currentQuantity')"
                ></b-form-input>
                <Tooltip :validations="$v.formObject.totalQuantity" />
              </b-form-group>

              <b-form-group
                id="input-group-minQuantity"
                :label="$t('items.minQuantity')"
                label-for="input-minQuantity"
                style="margin-left: 7px"
              >
                <b-form-input
                  id="input-minQuantity"
                  :class="{
                    'is-invalid': $v.formObject.minQuantity.$error,
                  }"
                  v-model="formObject.minQuantity"
                  type="number"
                  :step="formObject.quantityType == 'unitary' ? '1' : '.00001'"
                  :placeholder="$t('items.minQuantity')"
                ></b-form-input>
                <Tooltip :validations="$v.formObject.minQuantity" />
              </b-form-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div class="group-box">
            <b-form-group
              label-cols-lg="6"
              :label="$t('orders.order')"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="mb-0"
            >
              <b-form-group
                id="input-group-orderNote"
                :label="$t('general.note')"
                label-for="input-orderNote"
                style="margin-left: 7px"
              >
                <b-form-input
                  id="input-orderNote"
                  v-model="formObject.orderNote"
                  type="text"
                  :placeholder="$t('general.note')"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-isInternalOrderNote"
                label-for="input-isInternalOrderNote"
                style="margin-left: 7px"
              >
                <b-form-checkbox
                  id="input-isInternalOrderNote"
                  v-model="formObject.isInternalOrderNote"
                >
                  {{ $t('items.isInternal') }}
                </b-form-checkbox>
              </b-form-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <ItemSuppliers :item="item" @update-item="updateItem" />
    </b-form>
  </HeaderContentLayout>
</template>

<style scoped>
.group-box {
  border-radius: 5px;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 15px 20px;
  margin-bottom: 16px;
  background-color: #f5f5f5;
}
</style>
